<template>
  <div>
    <v-tooltip :disabled="!(mini || !currentRecording)" bottom>
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <v-btn
            v-if="!showOnlySnap"
            :disabled="!currentRecording"
            color="#eeeeee"
            elevation="0"
            height="32"
            @click.exact="openOverlay"
          >
            <p v-if="!mini" class="mb-0">{{ $t("Export") }}</p>
            <v-icon size="18" class="mb-1" :class="{ 'ml-2': !mini }" color="grey darken-2">
              fa-cloud-download-alt
            </v-icon>
          </v-btn>
        </span>
      </template>
      <span>{{ !!currentRecording ? $t("Export Footage") : $t("Please select a valid recording") }}</span>
    </v-tooltip>
    <v-dialog no-click-animation width="750px" v-if="showDialog" v-model="showDialog">
      <v-card>
        <v-tabs v-model="tab" color="primary" grow light>
          <div v-if="!showOnlySnap">
            <v-tab :ripple="false" v-for="item in items" :key="item.tab">
              {{ $t(item.name) }}
            </v-tab>
          </div>
          <v-tab v-if="showOnlySnap" :ripple="false">
            {{ $t("Snapshot") }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item :key="items[0].tab">
            <SnapshotTimeStamp
              :showDialog="showDialog"
              @close="closeOverlay"
              :camera="camera"
              :currentTime="currentTime"
              :offset="offset"
              :showOnlySnap="showOnlySnap"
              :rights="rights"
              :resolution="resolution"
            ></SnapshotTimeStamp>
          </v-tab-item>
          <v-tab-item v-if="!showOnlySnap" :key="items[1].tab">
            <VideoExportDialog
              :showDialog="showDialog"
              @close="closeOverlay"
              @export="exportStarted"
              :camera="camera"
              :currentTime="currentTime"
              :currentRecording="currentRecording"
              :offset="offset"
              :rights="rights"
              :accountTimeOffset="accountTimeOffset"
            ></VideoExportDialog>
          </v-tab-item>
          <v-tab-item v-show="!showOnlySnap" :key="items[2].tab">
            <VideoSummary
              :showDialog="showDialog"
              @close="closeOverlay"
              @export="exportStarted"
              :camera="camera"
              :currentTime="currentTime"
              :currentRecording="currentRecording"
              :offset="offset"
              :rights="rights"
            ></VideoSummary>
          </v-tab-item>
          <v-tab-item v-show="!showOnlySnap" :key="items[3].tab">
            <RecentExports
              :showDialog="showDialog"
              @close="closeOverlay"
              :camera="camera"
              :currentRecording="currentRecording"
              :accountTimeOffset="accountTimeOffset"
            ></RecentExports>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { reactive, toRefs, computed, watch } from "../../plugins/compositionApi";
import Theme from "../../service/themes";
import { getConfiguration } from "../../service/main";
import { t } from "../../service/locale";
import VideoExportDialog from "./VideoExportDialog";
import VideoSummary from "./VideoSummary";
import RecentExports from "./RecentExports";
import SnapshotTimeStamp from "./SnapshotTimeStamp";

export default {
  name: "FootageExportDialog",
  components: {
    VideoExportDialog,
    VideoSummary,
    RecentExports,
    SnapshotTimeStamp,
  },
  props: {
    camera: {
      type: Object,
    },
    currentRecording: Object,
    currentTime: Number,
    mini: Boolean,
    offset: Number,
    accountTimeOffset: Number,
    rights: Object,
    resolution: String,
    openSnapshot: Boolean,
    showOnlySnap: Boolean,
  },
  setup(props, context) {
    const config = getConfiguration();
    const themeName = config.hasOwnProperty("theme") ? config.theme : "Cameramanager";
    const colors = new Theme(themeName).colors();

    const data = reactive({
      showDialog: false,
      tab: null,
      items: [
        { tab: "1", name: "Snapshot", content: "Tab 1 Content" },
        { tab: "2", name: "Video Export", content: "Tab 2 Content" },
        { tab: "3", name: "24h Summary", content: "Tab 3 Content" },
        { tab: "4", name: "Recent Exports", content: "Tab 4 Content" },
      ],
    });

    const { openOverlay, closeOverlay, exportStarted } = useOverlay(data, context);

    watch(
      () => props.openSnapshot,
      () => {
        openOverlay();
        data.tab = 0;
      }
    );

    return { ...toRefs(data), openOverlay, closeOverlay, exportStarted };
  },
};

function useOverlay(data, context) {
  function openOverlay() {
    data.showDialog = true;
    context.emit("pause");
    data.tab = 1;
  }
  function closeOverlay() {
    data.showDialog = false;
  }
  function exportStarted() {
    data.tab = 3;
  }
  return { openOverlay, closeOverlay, exportStarted };
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/main";

.custom-tooltip {
  background-color: $primary;
  color: white;
  border-radius: 3px;
  padding: 1px 4px 0 4px;
  text-align: center;
  // white-space: pre;
}
.custom-label {
  width: 60px;
  white-space: pre-wrap;
  text-align: center;
}
.custom-label.active {
  color: #3498db;
}
.black-label-text {
  &::v-deep label {
    color: #555555;
    font-size: 14px;
  }
}
.overlay-z {
  z-index: 1000 !important;
}
</style>
